<template>
    <v-autocomplete
        v-on="$listeners"
        v-bind="$attrs"
        v-model="countryId"
        :items="countriesList"
        item-text="name"
        item-value="id"
        :rules="[requiredRule('Country')]"
        name="Country"
        label="Country (required)"
        required
        autocomplete="country-name"
        outlined
        dense
    />
</template>

<script>
import CountryList from "../../Mixins/CountryList";
import ValidationRules from "../../Mixins/ValidationRules";
import VModel from "../../Mixins/VModel";

export default {
    name: "CountryPicker",
    mixins: [CountryList, ValidationRules, VModel],

    computed: {
        countryId: {
            get() {
                return parseInt(this.model);
            },
            set(val) {
                this.model = val;
            },
        },
    },
};
</script>

<style scoped></style>
